import React from 'react';
import styled from 'styled-components';
import Icon from './Icon';
import { themes } from 'seal-ui-components';

const { fonts } = themes.baseTheme.texts;

const Svg = styled(Icon)`
    .cls-1 {
        font-size: 50px;
        font-family: ${fonts.globalHeader.family};
        font-weight: ${fonts.globalHeader.fontWeights.semibold};
        letter-spacing: -0.04em;
    }

    .cls-2 {
        letter-spacing: -0.02em;
    }

    .cls-3 {
        letter-spacing: -0.03em;
    }
`;

export const AnalyzerIcon = ({ className }) => {
    return (
        <Svg viewBox="0 0 466.88 106.78" className={className} id="Layer_1" data-name="Layer 1">
            <text className="cls-1" transform="translate(252.85 71.85)">
                Anal
                <tspan className="cls-2" x="95.9" y="0">
                    y
                </tspan>
                <tspan className="cls-3" x="119.75" y="0">
                    z
                </tspan>
                <tspan x="142.75" y="0">
                    er
                </tspan>
            </text>
            <path d="M36.32,35.94H51.43c9.59,0,15.77,7.74,15.77,18.33,0,5.83-2,10.95-5.72,14.12a16.06,16.06,0,0,1-10.65,3.46H36.32Zm14,29.63c6.83,0,9.49-4.16,9.49-11.3s-3.11-12.1-9.29-12.1H43.6v23.4Z" />
            <path d="M68.29,59c0-7.69,5.47-13.61,13.46-13.61S95.21,51.31,95.21,59,89.73,72.61,81.75,72.61,68.29,66.68,68.29,59Zm20,0c0-5-2.36-8.44-6.53-8.44S75.22,54,75.22,59s2.31,8.38,6.53,8.38S88.28,64,88.28,59Z" />
            <path d="M96.61,59c0-7.69,5-13.61,12.86-13.61,6.68,0,10.79,3.86,11.7,9.44h-6.68a4.72,4.72,0,0,0-4.72-4c-4.12,0-6.23,3.16-6.23,8.14s2,8.13,6.13,8.13a4.8,4.8,0,0,0,5.17-4.37h6.58c-.45,5.48-4.72,9.85-11.6,9.85C101.68,72.61,96.61,66.68,96.61,59Z" />
            <path d="M139.48,71.85v-3h-.15A8.28,8.28,0,0,1,132,72.56c-5.73,0-8.94-3.67-8.94-9.3V46.09h6.78v16c0,3,1.35,4.67,4.26,4.67,3.22,0,5.18-2.41,5.18-5.83V46.09h6.83V71.85Z" />
            <path d="M179.33,36.1h6.83v6.39h-6.83Zm0,10h6.83V71.85h-6.83Z" />
            <path d="M189,72.61h6.78c.55,1.6,2,2.86,5.17,2.86,3.87,0,5.72-1.86,5.72-5.38V67.28h-.15a8.31,8.31,0,0,1-6.73,3c-5.72,0-11.35-4.52-11.35-12.31s4.62-12.6,11.15-12.6a8.28,8.28,0,0,1,7.13,3.41h.11V46.09h6.57v23.8c0,3.62-1.15,6.08-3.06,7.84-2.16,2-5.47,2.91-9.29,2.91C194,80.64,189.7,77.63,189,72.61Zm18-14.77c0-3.77-2-7-6.13-7-3.47,0-5.78,2.71-5.78,7s2.31,6.93,5.83,6.93C205.27,64.82,207,61.66,207,57.84Z" />
            <path d="M223,49.6h.15a8.37,8.37,0,0,1,7.63-4.21c5.33,0,8.89,4,8.89,9.64V71.85h-6.83V56c0-2.76-1.61-4.72-4.47-4.72s-5.22,2.41-5.22,5.93V71.85h-6.83V46.09H223Z" />
            <path d="M163.77,50.21c-5.33-1.16-7.84-2-7.84-4.92,0-2.57,2.56-4.22,6.48-4.22,3.58,0,6.31,1.67,6.87,5h7c-.71-7-5.88-10.8-13.82-10.8S148.7,39,148.7,46c0,7.48,5.88,9.19,12.31,10.65,5.47,1.25,8.88,2,8.88,5.47,0,3.31-3.26,4.62-7,4.62-5.12,0-7.58-1.71-8.08-6H147.7c.25,7.59,5.77,11.91,15.51,11.91,8.09,0,14-4.07,14-11.35C177.18,53.57,171.15,51.81,163.77,50.21Z" />
            <path d="M242.46,50.85a2.72,2.72,0,1,1,2.71-2.72A2.72,2.72,0,0,1,242.46,50.85Zm0-5a2.29,2.29,0,1,0,2.29,2.29A2.29,2.29,0,0,0,242.46,45.84Z" />
            <path d="M241.52,46.73h.89a1.32,1.32,0,0,1,.86.2.88.88,0,0,1,.3.69.76.76,0,0,1-.54.76l.61,1.13h-.59l-.55-1H242v1h-.52Zm.52.45v.87h.52a.43.43,0,0,0,.49-.42.42.42,0,0,0-.22-.38,1.38,1.38,0,0,0-.55-.06Z" />
        </Svg>
    );
};
